/* Mobile nav burger (2026-08-17): toggles the board list behind a "Boards" button on
   narrow screens. Loaded with `defer`, so the DOM is already parsed when this runs.
   No-op on desktop (the CSS shows the board list regardless of .open) and on pages
   without a burger. Taps outside close any open panel; picking a board closes it. */
(function () {
  'use strict';

  function closeAll(exceptNav) {
    document.querySelectorAll('#topNav.open, #bottomNav.open').forEach(function (nav) {
      if (nav !== exceptNav) nav.classList.remove('open');
    });
  }

  document.querySelectorAll('.navBurger').forEach(function (btn) {
    var nav = btn.closest('nav');
    if (!nav) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // Cross-dismiss the other mobile menus (operator 2026-08-30: only one of
      // boards-burger / watched-list / settings may be open). stopPropagation
      // blocks their outside-click closers, so signal each explicitly.
      document.dispatchEvent(new CustomEvent('staffnav-close'));
      document.dispatchEvent(new CustomEvent('watcher-close'));
      if (window.settingsMenu && settingsMenu.close) { settingsMenu.close(); }
      var willOpen = !nav.classList.contains('open');
      closeAll(nav);
      // toggle with force arg (2026-08-17 fix): the old add-only branch never
      // removed .open when re-clicking to close — closeAll() skips this nav by
      // design (exceptNav), so the class stayed on and the panel stayed open.
      nav.classList.toggle('open', willOpen);
      btn.setAttribute('aria-expanded', String(willOpen));
    });

    // Close the panel after choosing a board (or any in-panel link).
    nav.querySelectorAll('.navLinkSpan a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  });

  // Tap outside the burger/panel closes any open panel.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.navBurger') && !e.target.closest('.navLinkSpan')) {
      closeAll();
    }
  });
})();
